import { SvgIcon, SvgIconProps } from '@mui/material';

export const SeoAuditIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox>
      <svg viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g
          clipPath='url(#clip0_6121_13099)'
          stroke='currentColor'
          strokeWidth={1.49871}
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <path d='M13.064 8.097A13.418 13.418 0 009.76 1.671a13.484 13.484 0 00-3.586 9.18c0 3.418 1.284 6.705 3.586 9.18a8.809 8.809 0 01-4.693-1.36 9.101 9.101 0 01-3.303-3.673 9.369 9.369 0 01.77-9.579 8.999 8.999 0 013.847-3.07 8.77 8.77 0 014.847-.555A8.876 8.876 0 0115.64 3.92a9.2 9.2 0 012.673 4.177M.793 10.848h7.62' />
          <path d='M11.613 13.726l2.72 2.967 5.07-5.564' />
        </g>
        <defs>
          <clipPath id='clip0_6121_13099'>
            <path fill='#fff' transform='matrix(1 0 0 -1 -1 23)' d='M0 0H21.5161V23H0z' />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
